import { AcumaticaRequestOptions, AcumaticaService } from '../acumatica.service';
import { AcumaticaEntity, AcumaticaEntityService } from './acumatica-entity';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Acumatica, AcumaticaFieldFormat } from '../acumatica-field-decorator';

@Injectable({
    providedIn: 'root'
})
export class SalesPricesInquiryService extends AcumaticaEntityService {
    constructor(acumatica: AcumaticaService) {
        super(acumatica, 'SalesPricesInquiry', SalesPricesInquiry);
    }

    get(inquiry: SalesPricesInquiry, options: AcumaticaRequestOptions = {}): Observable<SalesPricesInquiry> {
        return super.putEntity(inquiry, {
            ...{ message: "Getting Sales Prices" },
            ...options,
            ...{ expand: 'SalesPriceDetails' }
        });
    }
}

export class SalesPriceInquiryDetail extends AcumaticaEntity {
    @Acumatica() InventoryID!: string;
    @Acumatica() PriceType!: string;
    @Acumatica() PriceCode!: string | null;
    @Acumatica() BreakQty!: number;
    @Acumatica({ format: AcumaticaFieldFormat.Date }) EffectiveDate!: Date | null;
    @Acumatica({ format: AcumaticaFieldFormat.Date }) ExpiraitonDate!: Date | null;
    @Acumatica() Price!: number;
}

export class SalesPricesInquiry extends AcumaticaEntity {
    @Acumatica() InventoryID: string | null = null;
    @Acumatica() PriceType: string | null = null;
    @Acumatica() PriceCode: string | null = null;
    @Acumatica() EffectiveAsOf: Date | null = null;
    @Acumatica({ type: SalesPriceInquiryDetail, name: 'SalesPriceDetails' }) Details?: SalesPriceInquiryDetail[];

    constructor(init?: any) {
        super();
        Object.assign(this, init);
    }
}